import { render, staticRenderFns } from "./JobRevisionHeader.vue?vue&type=template&id=3b3de77a&lang=pug"
import script from "./JobRevisionHeader.vue?vue&type=script&lang=js"
export * from "./JobRevisionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports